var _path, _path2, _g, _path3, _path4, _g2, _rect, _rect2, _g3, _rect3, _rect4, _path5, _path6, _path7, _path8, _rect5, _circle, _circle2, _path9, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 82,
    width: 152,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_35)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#C51162"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "#59C4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 13,
    width: 60,
    height: 39
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_35)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#E57373"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91,
    cy: 30,
    rx: 4,
    ry: 6,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 13,
    width: 60,
    height: 23,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 14.5C90.4477 14.5 90 14.9477 90 15.5C90 16.0523 90.4477 16.5 91 16.5V14.5ZM102.694 21.6875C103.065 22.0968 103.697 22.1281 104.107 21.7573C104.516 21.3865 104.547 20.7541 104.176 20.3448L102.694 21.6875ZM106.759 24.0473C106.504 23.5579 105.899 23.3686 105.41 23.6246C104.921 23.8806 104.731 24.4848 104.987 24.9742L106.759 24.0473ZM106.425 28.9559C106.54 29.4959 107.072 29.84 107.612 29.7244C108.152 29.6088 108.496 29.0773 108.38 28.5373L106.425 28.9559ZM91 16.5C95.6375 16.5 99.8065 18.4999 102.694 21.6875L104.176 20.3448C100.926 16.7563 96.2256 14.5 91 14.5V16.5ZM104.987 24.9742C105.636 26.2139 106.124 27.5501 106.425 28.9559L108.38 28.5373C108.041 26.9518 107.49 25.4448 106.759 24.0473L104.987 24.9742Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 130,
    height: 120,
    rx: 18,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_35)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1086 120C93.0219 120.014 93.0143 120.022 93 120.11C93.0866 120.096 93.0943 120.088 93.1086 120ZM105.25 150.108L105.378 150C107.273 150 104.125 150.189 105.25 150.108ZM110 128.11C110.087 128.096 110.094 128.088 110.109 128C110.022 128.014 110.014 128.022 110 128.11ZM39 135C39.0143 135.088 39.022 135.096 39.1086 135.11C39.0943 135.022 39.0866 135.014 39 135Z",
    fill: "black",
    fillOpacity: 0.4
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 129,
    width: 68,
    height: 22,
    rx: 5,
    fill: "black",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 133,
    width: 60,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 141L78 133H66L72 141Z",
    fill: "#E1E6E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 141L90 133H78L84 141Z",
    fill: "#E1E6E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 141L102 133H90L96 141Z",
    fill: "#E1E6E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108 141L114 133H102L108 141Z",
    fill: "#E1E6E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 24,
    fill: "white",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 20,
    fill: "black",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.572 91.8153C102.874 92.2779 103.494 92.4082 103.956 92.1064C104.419 91.8046 104.549 91.185 104.247 90.7225L102.572 91.8153ZM99.5814 85.9555C99.1254 85.6438 98.5032 85.7608 98.1915 86.2168C97.8799 86.6728 97.9969 87.295 98.4529 87.6067L99.5814 85.9555ZM94.3567 85.6422C94.8853 85.8024 95.4436 85.5037 95.6037 84.9752C95.7639 84.4466 95.4652 83.8883 94.9367 83.7282L94.3567 85.6422ZM83.7205 84.1977C83.2073 84.4018 82.9567 84.9833 83.1608 85.4964C83.3649 86.0096 83.9464 86.2602 84.4596 86.0561L83.7205 84.1977ZM79.7602 89.0388C80.1637 88.6617 80.185 88.0289 79.8079 87.6254C79.4308 87.2219 78.798 87.2005 78.3945 87.5776L79.7602 89.0388ZM74.4566 93.1052C74.2324 93.6099 74.4598 94.2008 74.9645 94.425C75.4693 94.6492 76.0602 94.4218 76.2844 93.9171L74.4566 93.1052ZM104.247 90.7225C103.021 88.8427 101.433 87.2208 99.5814 85.9555L98.4529 87.6067C100.087 88.7238 101.49 90.1559 102.572 91.8153L104.247 90.7225ZM94.9367 83.7282C93.3731 83.2544 91.7154 83 90 83V85C91.5167 85 92.9792 85.2248 94.3567 85.6422L94.9367 83.7282ZM90 83C87.7839 83 85.6645 83.4246 83.7205 84.1977L84.4596 86.0561C86.1723 85.375 88.0411 85 90 85V83ZM78.3945 87.5776C76.7377 89.1261 75.3904 91.0029 74.4566 93.1052L76.2844 93.9171C77.1078 92.0633 78.2967 90.4066 79.7602 89.0388L78.3945 87.5776Z",
    fill: "white",
    fillOpacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 10,
    fill: "#C6080C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 4,
    fill: "#EE9337"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 1,
    fill: "#F5F94F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot5);
export default __webpack_public_path__ + "static/media/bot-5.901bc1691146f39246d4c13653cc6361.svg";
export { ForwardRef as ReactComponent };